export const LOAD_COUNTRY = "LOAD_COUNTRY";
export const ADD_COUNTRY = "ADD_COUNTRY";
export const UPDATE_COUNTRY = "UPDATE_COUNTRY";
export const DELETE_COUNTRY = "DELETE_COUNTRY";
export const LOAD_COUNTRY_FAILED = "LOAD_COUNTRY_FAILED";
export const PUBLISH_COUNTRY = "PUBLISH_COUNTRY";
export const UPDATE_CUTOFF_TIME = "UPDATE_CUTOFF_TIME";
export const LOAD_CENTRAL_WAREHOUSES = "LOAD_CENTRAL_WAREHOUSES";
export const LOAD_CENTRAL_WAREHOUSES_FAILED = "LOAD_CENTRAL_WAREHOUSES_FAILED";
export const SET_SELECTED_WAREHOUSE = "SET_SELECTED_WAREHOUSE";
export const LOAD_COUNTRIES = "LOAD_COUNTRIES";
export const LOAD_COUNTRIES_FAILED = "LOAD_COUNTRIES_FAILED";
export const LOAD_WH_COUNTRY_MAPPINGS = "LOAD_WH_COUNTRY_MAPPINGS";
export const LOAD_WH_COUNTRY_MAPPINGS_FAILED = "LOAD_WH_COUNTRY_MAPPINGS_FAILED";
export const UPDATE_WH_COUNTRY_MAPPINGS = "UPDATE_WH_COUNTRY_MAPPINGS";
